import React from 'react';

function DefaultAvatar() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <path d="M11,.5A10.5,10.5,0,1,0,21.5,11,10.49,10.49,0,0,0,11,.5Zm0,8.18a1.62,1.62,0,1,1-1.6,1.64A1.63,1.63,0,0,1,11,8.68Zm0,5.73a4.51,4.51,0,0,1,4.43,3.51,8.48,8.48,0,0,1-8.86,0A4.57,4.57,0,0,1,11,14.41Zm3.76-4.09a3.74,3.74,0,1,0-6.47,2.54A6.74,6.74,0,0,0,4.8,16.42a8.21,8.21,0,1,1,12.36,0,6.62,6.62,0,0,0-3.43-3.57A3.72,3.72,0,0,0,14.74,10.32Z" />
    </svg>
  );
}

export default DefaultAvatar;
